import React, { useEffect, useRef, useState } from "react";
import HeaderSidebar from "./Common/HeaderSidebar/HeaderSidebar";
import FloatingHeader from "./Common/FloatingHeader";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import useIsMobile from "@/hooks/useIsMobile";

const MemoizedFloatingHeader = React.memo(FloatingHeader);
const MemoizedHeaderSidebar = React.memo(HeaderSidebar);

const FloatingHeaderWrapper = ({ shouldDisplayFloatingHeader, headerProps }) => {

    const [showFloatingHeader, setShowFloatingHeader] = useState(true);

    const lastScrollY = useRef(window.scrollY);
    const scrollTimeout = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const currentY = window.scrollY;
            const delta = currentY - lastScrollY.current;

            if (Math.abs(delta) < 10) return;

            clearTimeout(scrollTimeout.current);

            const shouldHideHeader = delta > 0 && currentY > 50;
            const shouldShowHeader = delta < 0;

            if (shouldHideHeader) {
                scrollTimeout.current = setTimeout(() => {
                    setShowFloatingHeader(false);
                }, 120);
            } else if (shouldShowHeader) {
                scrollTimeout.current = setTimeout(() => {
                    setShowFloatingHeader(true);
                }, 80);
            }

            lastScrollY.current = currentY;
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(scrollTimeout.current);
        };
    }, []);

    if (!shouldDisplayFloatingHeader) return null;

    return (
        <div className={`floating-header-wrapper ${showFloatingHeader ? "visible" : "hidden"}`}>
            <MemoizedFloatingHeader {...headerProps} />
        </div>
    )
}

export const PageWrapper = React.forwardRef((props, ref) => {

    const {
        className = '',
        headerSidebarProps = {},
        headerProps = {},
        shouldDisplayHeaderSidebar = true,
        shouldDisplayFloatingHeader = true,
        renderGitchaDefaultHeader = null,
    } = props

    const { isGitchaDefaultWebsite } = useCurrentWebsite()
    const isMobile = useIsMobile()

    const showFloatingHeader = isGitchaDefaultWebsite && !isMobile && shouldDisplayFloatingHeader
    const showHeaderSidebar = !isGitchaDefaultWebsite || isMobile

    return (
        <>
            {shouldDisplayHeaderSidebar && showHeaderSidebar && (
                <MemoizedHeaderSidebar {...headerSidebarProps} />
            )}
            <div
                ref={ref}
                className={`
                    outer-wrap
                    position-relative
                    ${className}
                    agent-no-login`}
            >
                {renderGitchaDefaultHeader ? (
                    renderGitchaDefaultHeader
                ) : (
                    <FloatingHeaderWrapper
                        shouldDisplayFloatingHeader={showFloatingHeader}
                        headerProps={headerProps}
                    />
                )}
                <div> {props?.children} </div>
            </div>
        </>
    )

});
